import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getPostsByKitId = async ({ kitId }) => {
	if (!kitId) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getPostsByKitId')
	}
	try {
		const kitPostsQuerySnap = await firestore.collection('kits').doc(kitId).collection('posts').get()
		const postsDocSnaps = await Promise.all(kitPostsQuerySnap.docs.map(kitPostDocSnap => firestore.collection('posts').doc(kitPostDocSnap.ref.id).get()))
		const posts = postsDocSnaps.map(postDocSnap => postDocSnap.data()).filter(post => !post.deleted)

		return { posts }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, kitId, exception)
	}
}

export default getPostsByKitId



// WEBPACK FOOTER //
// ./src/dataservices/getPostsByKitId.js